import React from 'react';
import APIServices from '@/apiUtils/APIServices';
import { GetStaticProps } from 'next';
import useWidth from '@/helpers/widthUtil';
import dynamic from 'next/dynamic';

const LandingLayout = dynamic(() => import('@/components/landing/home/LandingLayout'), { ssr: false });
const SEO = dynamic(() => import('@/components/landing/seo'), { ssr: false });

function About(props) {
  const { isMobile } = useWidth();
  return (
    <>
      <SEO
        meta_title={'About Us | Learnsic'}
        meta_description={props?.data?.data?.connect}
        meta_keywords={'contact us, learnsic, learnsic address'}
        photo={''}
        canonical="about-us"
      />
      <LandingLayout>
        <div className="custom-container">
          <div
            className={`about-us-container ${
              !isMobile ? 'mt-50 mb-100' : 'mt-3 mb-5 pl-3 pr-3'
            }`}
          >
            <div className="align-items-center row">
              <div className="col-lg-7">
                <h1 className="mb-4">About Us</h1>
                <div
                  className="text-justify my-auto content text-muted"
                  dangerouslySetInnerHTML={{
                    __html: props?.data?.data?.description,
                  }}
                />
              </div>
              {!isMobile && (
                <div className="col-lg-4 col-md-4">
                  <img
                    src="/images/aboutus.svg"
                    alt="image"
                    className="float-right ml-5"
                    width={'300px'}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </LandingLayout>
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  const { data, success } = await new APIServices(`company/about/`).get();
  return {
    props: {
      data: success ? data : {},
    },
    revalidate: 300,
  };
};

export default About;
